export default async function tryCatch(promiseThunk = () => new Promise()) {
	try {
		const result = await promiseThunk()
		return [null, result]
	} catch (error) {
		return [error, null]
	}
}
